<div class="table-container">
  <table mat-table [dataSource]="errors" matSort>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "admin.dialogs.id" | translate }} </th>
      <td mat-cell *matCellDef="let error">{{error.id}}</td>
    </ng-container>

    <ng-container matColumnDef="key-figures">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "admin.errors.key-figures" | translate }} </th>
      <td mat-cell *matCellDef="let error">{{error.keyFigures}}</td>
    </ng-container>

    <ng-container matColumnDef="percentage">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "admin.errors.percentage" | translate }} </th>
      <td mat-cell *matCellDef="let error">{{error.percentage}}%</td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let error">
        <mat-icon (click)="editError(error)" color="primary">edit</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>

